import * as firebase from 'firebase';

export function getOrderPageFromFirebase({ page = 1, limit = 10} = {}){
  const startAtValue = ((page - 1) * limit) + 1;
  console.log(startAtValue)
  const ref = firebase.database().ref().child('cart_sessions').orderByChild('no').startAt(startAtValue).limitToFirst(limit)
  return getOrdersFromRef(ref);
}

export function getOrdersByDateRange(timestampFrom, timestampTo){
  const ref = firebase.database().ref().child('cart_sessions').orderByChild('date').startAt(timestampFrom).endAt(timestampTo);
  return getOrdersFromRef(ref);
}


export function getOrdersFromRef(ref) {
  return new Promise((resolve, reject) => {
    ref.on('value', snapshot => {
      if (!snapshot.val()) {
        return reject("no more data");
      }
      const orderList = [];

      snapshot.forEach((child) => {
        orderList.push({ ...child.val(), key : child.key })
      })

      const newOrderList = orderList.map(async (item) => {
        const products = await attachProductData({ products: item.products });
        return { ...item, products,  amount: calculateOrderTotal({ products })}
      })

      Promise.all(newOrderList)
      .then(orders =>  attachClientDataFromList(orders))
      .then(orderWithClient => {
        return resolve(orderWithClient);
      });
    })
  })
}

export function attachClientDataFromList(orderList){
  return new Promise((resolve, reject) => {
    const orderWithClient = [];
    orderList.forEach((order) => {
      attachClientData(order)
      .then(data => {
        orderWithClient.push({...order, ...data});
        if (orderWithClient.length === orderList.length ) {
          resolve(orderWithClient);
        }
      })
    })
  })
}


export function attachClientData(order){
  return new Promise((resolve, reject) => {
    firebase.database().ref().child('orders').child(order.key).on('value', client => {
      if (!client.val()) {
        resolve({ client: {} });
      } else {
        firebase.database().ref().child('clients').child(client.val()).on('value', clientObj => {
          if (!clientObj.val()) {
            resolve({ client: {} })
          } else {
            resolve({ client: {...clientObj.val(), key: clientObj.key } })
          }
        })
      }
    })
  })
}

export function attachProductData({ products = {} }){
  return new Promise((resolve, reject) => {
    const productsList = [];
    if (Object.keys(products).length === 0) { 
      return resolve([])
    }
    for (const key in products) {
      firebase.database().ref().child('products').child(key).on('value', product => {
        productsList.push({...product.val(), key: product.key, client_quantity: products[product.key] });
        if (Object.keys(products).length === productsList.length) {
          resolve(productsList);
        }
      })
    }
  })
}

export async function updateOrderToFirebase({ key = null, data = {} }){
  try {
    return await firebase.database().ref().child('cart_sessions').child(key).update(data);
  } catch (e) {
    throw e;
  }
}

export async function deleteOrderFromFirebase({ key = null}){
  try {
    await updateAfterOrdersNo(key);
    await firebase.database().ref().child('cart_sessions').child(key).remove();
    await firebase.database().ref().child('orders').child(key).remove();
    return key;
  } catch (e) {
    throw e;
  }
}

function updateAfterOrdersNo(key){
  const orderRef = firebase.database().ref().child('cart_sessions');
  return new Promise((resolve, reject) => {
    orderRef.child(key).once('value', snapshot => {
      if (snapshot.val()) {
        orderRef.orderByChild('no').startAt(snapshot.val().no).once('value', orders => {
          orders.forEach(order => {
            orderRef.child(order.key).update({ no: order.val().no - 1 });
          })

          firebase.database().ref().child('order_count').once('value', count => {
            firebase.database().ref().child('order_count').set(count.val() - 1);
          })
          resolve();
        })
      } else {
        reject('order not found');
      }
    })
  })
}



// ///////////

export function calculateOrderTotal({ products = []}){
  return products.reduce((sum, product) => sum + calculateSingleProductTotal({
    price: product.price_item,
    quantity: product.client_quantity,
    discount: product.zbritje,
    pcscase: product.pcscase
  }), 0.0)
}

export function calculateSingleProductTotal({ pcscase, price, quantity, discount = 0 }){
  return pcscase * price * quantity * ( 1 - (discount / 100));
}

export function formatNumber(number, isInt = false) {
  if(!isInt){
    return new Intl.NumberFormat().format(parseFloat(number.toFixed(2)))
  }
  return new Intl.NumberFormat().format(number);
}



// WEBPACK FOOTER //
// ./src/utils/orderService.js